<div class="panel panel-default" [formGroup]="form">
  <div class="panel-body" style="min-height: 90px">

    <fieldset [disabled]="!editMode">

      <div class="flex-row">
        <div class="item">

          <div class="row">

            <div class="col-md-9">
              <div class="form-group">
                <div class="control">
                  <label>Server</label>
                  <input class="form-control" [class.invalid-state-border]="fcHost.invalid" formControlName="host" [readonly]="!editMode" type="text" />
                  <div [class.invisible]="!fcHost.invalid || (fcHost.pristine && fcHost.untouched)">
                    <span class="error">Server is required</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <div class="control">
                  <label>Port</label>
                  <input class="form-control" [class.invalid-state-border]="fcPort.invalid" formControlName="port" [readonly]="!editMode" type="number" />
                  <div [class.invisible]="!fcPort.invalid || (fcPort.pristine && fcPort.untouched)">
                    <span class="error">Port is required</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="row">

            <div class="col-md-12">
              <div class="form-group">
                <div class="control control-checkbox lg control-form-group">
                  <label>
                    This server requires an encrypted connection (SSL/TLS)
                    <input formControlName="enableSsl" type="checkbox" />
                    <i></i>
                  </label>
                </div>
              </div>
            </div>

          </div>
          <div class="row">

            <div class="col-md-12">
              <div class="form-group">
                <div class="control">
                  <label>Sender</label>
                  <input class="form-control" [class.invalid-state-border]="fcSender.invalid" formControlName="sender" [readonly]="!editMode" type="text" />
                  <div [class.invisible]="!fcSender.invalid || (fcSender.pristine && fcSender.untouched)">
                    @if (fcSender.errors?.required) {
                      <span class="error">Sender is required</span>
                    }
                    @if (fcSender.errors?.email) {
                      <span class="error">Sender must be a valid email address</span>
                    }
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
        <div class="item">

          <div class="row">

            <div class="col-md-12">
              <div class="form-group">
                <div class="control control-checkbox lg control-form-group">
                  <label>
                    This server requires authentication
                    <input formControlName="useCredentials" type="checkbox" />
                    <i></i>
                  </label>
                </div>
              </div>
            </div>

          </div>
          <div class="row">

            <div class="col-md-12">
              <div class="form-group">
                <div class="control">
                  <label>Username</label>
                  <input class="form-control" [class.invalid-state-border]="fcUsername.invalid" formControlName="username" [readonly]="!editMode" type="text" />
                  <div [class.invisible]="!fcUsername.invalid || (fcUsername.pristine && fcUsername.untouched)">
                    <span class="error">Username is required</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="row">

            <div class="col-md-12">
              <app-password decorator formControlName="password" caption="Password" [validate]="false" [readonly]="!editMode" [allowShowPassword]="allowShowPassword()" section="mail-settings"></app-password>
            </div>

          </div>

        </div>
      </div>

    </fieldset>

    <div class="row" *bizPermissionRequired="'Mail_Action_Settings_Edit'">
      <div class="col-md-12 relative">
        @if (!editMode) {
          <button type="button" class="btn btn-primary" (click)="editClicked()">Edit</button>
        }
        @if (editMode) {
          <button type="button" class="btn btn-primary" (click)="saveClicked()" [disabled]="form.invalid">Save</button>
        }
        @if (editMode) {
          <button type="button" class="btn btn-link" (click)="cancelClicked()">cancel</button>
        }
        @if (!editMode) {
          <button type="button" class="btn btn-link" (click)="sendTestMail()">Send test mail</button>
        }
      </div>
    </div>

  </div>
</div>
